__turbopack_context__.v({
  "className": "inter_ebf2caad-module__j0SfYq__className",
});
